import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpResponse, HttpUtilService } from "../http-util.service";

@Injectable({
  providedIn: "root",
})
export class DailyIssueChequeReportService {
  constructor(private http: HttpUtilService) {}

  GetDataDailyIssueChequeReport(model: {
    FromDate: string;
    ToDate: string;
    Type: string;
  }): Observable<HttpResponse<any>> {
    return this.http.post(
      `AutopacReportService.asmx/GetDataDailyIssueChequeReport`,
      {
        model: model,
      },
    );
  }
}
